import { render } from "./PostCardStarButton.vue?vue&type=template&id=78acfdd7&scoped=true"
import script from "./PostCardStarButton.vue?vue&type=script&lang=js"
export * from "./PostCardStarButton.vue?vue&type=script&lang=js"

import "./PostCardStarButton.vue?vue&type=style&index=0&id=78acfdd7&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78acfdd7"]])

export default __exports__